export const shouldForwardPropExclude =
    (...props: string[]) =>
    (prop: PropertyKey): boolean =>
        typeof prop !== 'string' || !props.includes(prop as string);
